import { AppComponent } from './app.component';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRouting, AppRoutingProviders } from './app.routing';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

// Pantallas
import { BackendCallbackComponent } from './screens/backend-callback/backend-callback.component';
import { ForgotPasswordComponent } from './screens/forgot-password/forgot-password.component';
import { HomeComponent } from './screens/home/home.component';
import { UserProfileComponent } from './screens/user-profile/user-profile.component';
import { MeansOfPaymentRegistrationResultComponent } from './screens/means-of-payment-registration-result/means-of-payment-registration-result.component';
import { NotFoundComponent } from './screens/not-found/not-found.component';
import { PlayerComponent } from './screens/player/player.component';
import { PricingComponent } from './screens/pricing/pricing.component';
import { RecoverPasswordComponent } from './screens/recover-password/recover-password.component';
import { SignInComponent } from './screens/sign-in/sign-in.component';
import { SignUpComponent } from './screens/sign-up/sign-up.component';
import { SubscriptionResultComponent } from './screens/subscription-result/subscription-result.component';
import { SummaryAndSubscriptionConfirmationComponent } from './screens/summary-and-subscription-confirmation/summary-and-subscription-confirmation.component';

// Componentes
import { ForgotPasswordFormComponent } from './components/forgot-password-form/forgot-password-form.component';
import { LoadingComponent } from './components/loading/loading.component';
import { MenuComponent } from './components/menu/menu.component';
import { PlanRequiredFormComponent } from './components/plan-required-form/plan-required-form.component';
import { SignInFormComponent } from './components/sign-in-form/sign-in-form.component';
import { SignUpFormComponent } from './components/sign-up-form/sign-up-form.component';

@NgModule({
  declarations: [
    AppComponent,
    // Pantallas
    BackendCallbackComponent,
    ForgotPasswordComponent,
    HomeComponent,
    UserProfileComponent,
    MeansOfPaymentRegistrationResultComponent,
    NotFoundComponent,
    PlayerComponent,
    PricingComponent,
    RecoverPasswordComponent,
    SignInComponent,
    SignUpComponent,
    SubscriptionResultComponent,
    SummaryAndSubscriptionConfirmationComponent,
    // Componentes
    ForgotPasswordFormComponent,
    LoadingComponent,
    MenuComponent,
    PlanRequiredFormComponent,
    SignInFormComponent,
    SignUpFormComponent
  ],
  imports: [
    AppRouting,
    BrowserModule,
    FontAwesomeModule,
    FormsModule,
    HttpClientModule
  ],
  providers: [AppRoutingProviders],
  bootstrap: [AppComponent]
})
export class AppModule { }
